<template>
  <v-dialog v-model="isOpen" persistent max-width="450">
    <v-card class="align-center text-center">
      <v-card-title class="headline justify-center">
        {{ title }}
      </v-card-title>
      <v-card-text v-if="bodyText"> {{ bodyText }} </v-card-text>

      <v-card-actions class="d-flex justify-space-between pb-5">
        <v-btn @click="$emit('update:isOpen'), $emit('cancelClick')" color="error" class="flex-grow-1">
          Cancelar
        </v-btn>
        <v-btn :loading="isConfirmBtnLoading" @click="$emit('confirmClick')" color="success" class="flex-grow-1">
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isOpen: {
      default: false,
      type: Boolean
    },
    title: {
      default: 'Você deseja confirmar essa ação?',
      type: String
    },
    confirmButtonText: {
      default: 'Confirmar',
      type: String
    },
    confirmText: {
      default: 'Confirmar',
      type: String
    },
    bodyText: {
      default: null,
      type: String
    },
    isConfirmBtnLoading: {
      default: false,
      type: Boolean
    }
  }
};
</script>

<style></style>
